import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase-client';

function getWaitlistConfig(source = {}) {
  if (source?.waitlist && typeof source.waitlist === 'object') return source.waitlist;
  if (source?.modules?.waitlist && typeof source.modules.waitlist === 'object') return source.modules.waitlist;
  return {};
}

export function isWaitlistModuleEnabled(source = {}) {
  return getWaitlistConfig(source)?.enabled === true;
}

export function isWaitlistJoinRoutingEnabled(source = {}) {
  const waitlist = getWaitlistConfig(source);
  return waitlist?.enabled === true && waitlist?.joinRoutingEnabled === true;
}

export function normalizePendingMemberStatus(value) {
  return typeof value === 'string' ? value.trim().toLowerCase() : '';
}

export function isPendingApprovalStatus(value) {
  return normalizePendingMemberStatus(value) === 'waiting';
}

export function isWaitlistedStatus(value) {
  return normalizePendingMemberStatus(value) === 'waitlisted';
}

export function getPendingMemberDisplayName(member = {}) {
  const fullName = [member.firstName, member.lastName].filter(Boolean).join(' ').trim();
  return (
    member.displayName
    || member.requestedByName
    || fullName
    || member.username
    || member.formResponses?.find((response) => response?.id === 'fullName')?.value
    || 'Unnamed'
  );
}

function toMillis(value) {
  const date =
    typeof value?.toDate === 'function'
      ? value.toDate()
      : value instanceof Date
        ? value
        : null;
  return date instanceof Date && !Number.isNaN(date.getTime()) ? date.getTime() : Number.POSITIVE_INFINITY;
}

export function compareWaitlistMembers(a = {}, b = {}) {
  const aPriority = Number.isFinite(Number(a?.waitlistPriority)) ? Number(a.waitlistPriority) : Number.POSITIVE_INFINITY;
  const bPriority = Number.isFinite(Number(b?.waitlistPriority)) ? Number(b.waitlistPriority) : Number.POSITIVE_INFINITY;
  if (aPriority !== bPriority) return aPriority - bPriority;

  const aWaitlistedAt = toMillis(a?.waitlistedAt ?? a?.createdAt);
  const bWaitlistedAt = toMillis(b?.waitlistedAt ?? b?.createdAt);
  if (aWaitlistedAt !== bWaitlistedAt) return aWaitlistedAt - bWaitlistedAt;

  const aName = getPendingMemberDisplayName(a);
  const bName = getPendingMemberDisplayName(b);
  const nameCompare = aName.localeCompare(bName, undefined, { sensitivity: 'base' });
  if (nameCompare !== 0) return nameCompare;

  return String(a?.id || '').localeCompare(String(b?.id || ''), undefined, { sensitivity: 'base' });
}

export function sortWaitlistMembers(members = []) {
  return [...(Array.isArray(members) ? members : [])].sort(compareWaitlistMembers);
}

export async function getNextWaitlistPriority(teamId) {
  const normalizedTeamId = typeof teamId === 'string' ? teamId.trim() : '';
  if (!normalizedTeamId) return 1;

  const snap = await getDocs(collection(db, 'teams', normalizedTeamId, 'pendingMembers'));
  let maxPriority = 0;

  snap.docs.forEach((docSnap) => {
    const data = docSnap.data() || {};
    if (!isWaitlistedStatus(data.status)) return;
    const value = Number(data.waitlistPriority);
    if (Number.isFinite(value) && value > maxPriority) {
      maxPriority = value;
    }
  });

  return maxPriority + 1;
}
